module.exports = __webpack_public_path__ + "img/doen-login.7b7f73e.jpg";